import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../Bem/Bem';
import { confirm } from '../Confirm/Confirm';

import './ConfirmBrandLiftStop.css';
import * as keyset from './ConfirmBrandLiftStop.i18n';

const i18n = i18nFactory(keyset);

export interface BrandliftActionCampaign {
    id: string;
    name: string;
}

export function confirmBrandLiftStop(campaigns: BrandliftActionCampaign[]): Promise<void> {
    return confirm({
        message: '',
        declineText: i18n('cancel'),
        successText: i18n('stop'),
        children: (
            <div className={Bem.cls('confirm-brand-lift-action')}>
                <div className={Bem.cls('confirm-brand-lift-action', 'header')}>
                    {i18n('stop-active-brand-lift-for-campaigns')}
                </div>
                <div className={Bem.cls('confirm-brand-lift-action', 'content')}>
                    {campaigns.map(el => (
                        <div className={Bem.cls('confirm-brand-lift-action', 'item')}>
                            {el.name} (№ {el.id})
                        </div>
                    ))}
                </div>
                <div className={Bem.cls('confirm-brand-lift-action', 'footer')}>
                    {i18n('stop-active-brand-lift-for-campaigns-helper')}
                </div>
            </div>
        )
    });
}
